// Meta Pixel + TikTok Pixel + GA4 — loaded only if the corresponding env var is set,
// so this is safe to ship before the ad accounts exist (no-op until IDs are added).
const META_ID = process.env.REACT_APP_META_PIXEL_ID;
const TIKTOK_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID;
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

export function initPixels() {
  if (initialized) return;
  initialized = true;

  if (META_ID) {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', META_ID);
    window.fbq('track', 'PageView');
  }

  if (TIKTOK_ID) {
    /* eslint-disable */
    !function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = w[t] = w[t] || [];
      ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"];
      ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (t) { for (var e = ttq._i[t] || [], n = 0; n < e.methods.length; n++) ttq.setAndDefer(e, e.methods[n]); return e; };
      ttq.load = function (e, n) {
        var r = "https://analytics.tiktok.com/i18n/pixel/events.js", o = n && n.partner;
        ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r;
        ttq._t = ttq._t || {}; ttq._t[e] = +new Date();
        ttq._o = ttq._o || {}; ttq._o[e] = n || {};
        var s = d.createElement("script"); s.type = "text/javascript"; s.async = true;
        s.src = r + "?sdkid=" + e + "&lib=" + t;
        var a = d.getElementsByTagName("script")[0]; a.parentNode.insertBefore(s, a);
      };
      ttq.load(TIKTOK_ID);
      ttq.page();
    }(window, document, 'ttq');
    /* eslint-enable */
  }

  if (GA_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID);
  }
}

export function trackPageView(path) {
  if (window.fbq) window.fbq("track", "PageView");
  if (window.ttq) window.ttq.page();
  if (window.gtag && GA_ID) window.gtag("event", "page_view", { page_path: path });
}

export function trackViewContent(product) {
  if (!product) return;
  if (window.fbq) window.fbq("track", "ViewContent", { content_ids: [product.id], content_name: product.title, value: product.price, currency: "USD" });
  if (window.ttq) window.ttq.track("ViewContent", { contents: [{ content_id: product.id, content_name: product.title }], value: product.price, currency: "USD" });
  if (window.gtag) window.gtag("event", "view_item", { currency: "USD", value: product.price, items: [{ item_id: product.id, item_name: product.title }] });
}

export function trackAddToCart(product, qty = 1) {
  if (!product) return;
  const id = product.product_id || product.id;
  const value = product.price * qty;
  if (window.fbq) window.fbq("track", "AddToCart", { content_ids: [id], content_name: product.title, value, currency: "USD" });
  if (window.ttq) window.ttq.track("AddToCart", { contents: [{ content_id: id, content_name: product.title }], value, currency: "USD" });
  if (window.gtag) window.gtag("event", "add_to_cart", { currency: "USD", value, items: [{ item_id: id, item_name: product.title, quantity: qty }] });
}

export function trackInitiateCheckout(items, total) {
  const ids = (items || []).map((i) => i.product_id);
  if (window.fbq) window.fbq("track", "InitiateCheckout", { content_ids: ids, value: total, currency: "USD" });
  if (window.ttq) window.ttq.track("InitiateCheckout", { contents: (items || []).map((i) => ({ content_id: i.product_id, content_name: i.title })), value: total, currency: "USD" });
  if (window.gtag) window.gtag("event", "begin_checkout", { currency: "USD", value: total, items: (items || []).map((i) => ({ item_id: i.product_id, item_name: i.title, quantity: i.quantity })) });
}

export function trackPurchase(order) {
  if (!order) return;
  const ids = (order.items || []).map((i) => i.product_id);
  if (window.fbq) window.fbq("track", "Purchase", { content_ids: ids, value: order.total, currency: "USD" });
  if (window.ttq) window.ttq.track("CompletePayment", { value: order.total, currency: "USD", contents: (order.items || []).map((i) => ({ content_id: i.product_id })) });
  if (window.gtag) window.gtag("event", "purchase", { transaction_id: order.id, currency: "USD", value: order.total, items: (order.items || []).map((i) => ({ item_id: i.product_id, item_name: i.title, quantity: i.quantity })) });
}
